import React from "react";
import { connect } from "react-redux";
import { reset } from "redux-form";
import * as agent from "../agent";
import Gallery from "./Gallery";
import { DUPLICATE_CLIENT, CLIENT_LOADED, CONTRACT_UPDATED, MESSAGE_SENDED } from "../constants/actionTypes";
import { LoanStatuses, Source, LoanTypes, Office } from "../constants/enums";
import { FormattedDate, FormattedNumber } from "react-intl";
import { formatPhone } from "../utility";
import PrimaryDivider from './PrimaryDivider';
import InnerLink from './InnerLink';
import LoanDraft from './LoanDraft';
import LoanSecurityCheck from './LoanSecurityCheck';
import LoanApproved from './LoanApproved';
import LoanActive from './LoanActive';
import LoanTrade from './LoanTrade';
import LoanClosed from './LoanClosed';
import LoanDenied from './LoanDenied';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import FaceIcon from '@material-ui/icons/Face';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import SwipeableViews from 'react-swipeable-views';
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';

const icons = {
    "status": <CheckIcon />,
    "files": <CheckIcon />,
    "info": <CheckIcon />,
    "checks": <CheckIcon />
};

const LoanInfo = ({
    client: { _id: clientId, firstname, secondname, thirdname, birthDate, email, address, passport = {}, phone, createdAt: clientCreated, source } = {},
    car: { _id: carId, createdAt, brand, model, year, loan: {type, value, office, duration, status} = {},
        contract: { programDetails = {}, penaltySum, prolongationDate, payments = [], creationDate, history: { programType = [], rates = [] } = {}  } = {}} }) => (
    <Grid container justify="center" spacing={32}>
        <Grid item xs={4}>
            <Typography variant="h5" >Данные клиента:</Typography>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>ФИО</TableCell>
                        <TableCell>{secondname} {firstname} {thirdname}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Телефон</TableCell>
                        <TableCell>{`${formatPhone(phone)}`}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Дата рождения</TableCell>
                        <TableCell>{birthDate}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Паспортные данные</TableCell>
                        <TableCell>{passport.serie} {passport.number}, выдан {passport.date}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Источник</TableCell>
                        <TableCell>{Source[source]}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Электронная почта</TableCell>
                        <TableCell>{email}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Дата регистрации</TableCell>
                        <TableCell>
                            <FormattedDate value={clientCreated}
                                           day="numeric"
                                           month="numeric"
                                           year="numeric" />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Grid container justify="center" style={{ marginTop: 10 }}>
                <InnerLink href={`/client/${clientId}`} label="Редактировать" />
            </Grid>
        </Grid>
        <Grid item xs={4}>
            <Typography variant="h5" >Данные заявки:</Typography>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>Автомобиль</TableCell>
                        <TableCell>{brand} {model}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Год</TableCell>
                        <TableCell>{year}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Планируемая сумма</TableCell>
                        <TableCell>
                            <FormattedNumber value={value}
                                             style={`currency`}
                                             currency="RUB"
                                             minimumFractionDigits={0} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Программа</TableCell>
                        <TableCell>{LoanTypes[type]}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Срок</TableCell>
                        <TableCell>{duration} мес.</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Офис</TableCell>
                        <TableCell>{Office[office]}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Дата обращения</TableCell>
                        <TableCell>
                            <FormattedDate value={createdAt}
                                           day="numeric"
                                           month="numeric"
                                           year="numeric" />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Grid container justify="center" style={{ marginTop: 10 }}>
                <InnerLink href={`/client/${clientId}/editcar/${carId}`} label="Редактировать" />
            </Grid>
        </Grid>
        {["ACTIVE","TRADE","CLOSED"].includes(status) &&
            <Grid item xs={4}>
                <Typography variant="h5" >Данные договора:</Typography>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Сумма</TableCell>
                            <TableCell>
                                <FormattedNumber value={programDetails.sum}
                                                 style={`currency`}
                                                 currency="RUB"
                                                 minimumFractionDigits={0} />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Программа</TableCell>
                            <TableCell>
                                {LoanTypes[programDetails.programType]}
                                {programType.length > 0 &&
                                    <React.Fragment>
                                        История изменений:
                                        {programType.map((p, i) => <Typography key={i}>{`${(new Date(p.date)).toLocaleDateString("ru-RU")}: ${LoanTypes[p.value]}`}</Typography>)}
                                    </React.Fragment>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Процентные ставки</TableCell>
                            <TableCell>
                                {`${programDetails.rates.join("%, ")}%`}
                                {rates.length > 0 &&
                                    <React.Fragment>
                                        История изменений:
                                        {rates.map((r, i) => <Typography key={i}>`${(new Date(r.date)).toLocaleDateString("ru-RU")}: ${r.value.join("%, ")}%`</Typography>)}
                                    </React.Fragment>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Сумма штрафов</TableCell>
                            <TableCell>
                                <FormattedNumber value={penaltySum}
                                                 style={`currency`}
                                                 currency="RUB"
                                                 minimumFractionDigits={0} />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Платежи</TableCell>
                            <TableCell>
                                {payments.length ?
                                    payments.map((p, i) => <Typography key={i}>{`${new Date(p.date).toLocaleDateString("ru-RU")}: ${p.sum.toLocaleString('ru-RU')} ₽`}</Typography>)
                                    : "Платежей еще не было"}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Дата заключения</TableCell>
                            <TableCell>
                                <FormattedDate value={creationDate}
                                               day="numeric"
                                               month="numeric"
                                               year="numeric" />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Дата пролонгации</TableCell>
                            <TableCell>
                                <FormattedDate value={prolongationDate}
                                               day="numeric"
                                               month="numeric"
                                               year="numeric" />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Grid container justify="center" style={{ marginTop: 10 }}>
                    <InnerLink href={`/client/${clientId}/editcontract/${carId}`} label="Редактировать" />
                </Grid>
            </Grid>
        }
    </Grid>
)

const StatusPanel = ({ carId, status, onStatusSubmit }) => (
    <Grid container item xs justify="flex-start" alignItems="flex-start" spacing={32}>
        <Grid item>
            <Typography variant="h5">Статус: </Typography>
        </Grid>
        {Object.keys(LoanStatuses).filter(s => s !== "TRADE").map((s, i) => {
            const a = Object.keys(LoanStatuses).indexOf(s);
            const b = Object.keys(LoanStatuses).indexOf(status);
            return (
                <Grid item key={i}>
                    <Chip icon={ s === "DENIED" ? <ClearIcon /> : a < b ? <CheckIcon /> : a === b ? <LocationSearchingIcon /> : <FaceIcon />}
                          onClick={ s === "DENIED" ? () => { if(window.confirm("Подтвердите отказ в займе")) onStatusSubmit(carId, "DENIED") } : null }
                          label={LoanStatuses[s]} />
                </Grid>
            )}
        )}
    </Grid>
);

class Loan extends React.Component {

    state = {
        value: 0
    };

    componentDidMount() {
        this.fetchData();
    };

    fetchData() {
        const { clientId } = this.props;
        agent.Client.get(clientId)
            .then(this.props.onLoad)
            .catch(err => alert(err));
    }

    switchTab = (e, value) => this.setState({ value });

    render() {
        const { value } = this.state;

        const { client,
                carId,
                manager,
                userPermissions,
                onDuplicateClient,
                onStatusSubmit,
                onClientDetailsSubmit,
                onCarDetailsSubmit,
                onProgramDetailsSubmit,
                onContractSign,
                onTradeCar,
                onTradeStatusSubmit,
                onContractIncrease,
                onContractRepay,
                onAddComment,
                onDeleteComment,
                history } = this.props;

        const car = client && client.cars.find(car => car._id === carId);
        if (!car) return <div/>;

        const {
            trade: { trader, prices, purchaser, status: tradeStatus = "FIRST" } = {},
            contract: { _id: contractId, carDetails = {}, status: contractStatus, programDetails: {programType, sum} = {} } = {},
            loan: { status } = {},
            number_id,
            securityDetails: {
                isNKBIRequested,
                isNKBIFetched,
                nkbiReportLink,
                nkbiRequestDate,
                nkbiRequestId,
                nkbi
            } = {}
        } = car;

        const tabs = Object.assign({}, {
            "status": "Управление статусом",
            "files": "Файлы",
            "info": "Информация"
        }, ["DRAFT", "DENIED"].includes(status) ? {} : {"checks": "Проверки"}  );

        const isContract = ["ACTIVE", "TRADE", "CLOSED"].includes(status);

        return (
            <Fade in={true}>
                <div style={{ position: "relative" }}>
                    <Typography variant="h4">{ isContract ? "Договор" : "Заявка" } № {number_id}</Typography>
                    <PrimaryDivider />
                    {status !== "CLOSED" && <StatusPanel status={status}
                                                         carId={car._id}
                                                         onStatusSubmit={onStatusSubmit} />}
                    <Button color="primary" style={{ position: "absolute", zIndex: "999", top: "120px" }} onClick={history.goBack} variant="outlined"><ChevronLeftIcon />Назад</Button>
                    <Tabs value={value}
                          onChange={this.switchTab}
                          centered >
                        {Object.keys(tabs).map((tab, i) => <Tab key={i}
                                                                label={tabs[tab]}
                                                                classes={{ labelContainer: "text-centered" }}
                                                                icon={icons[tab]} />
                        )}
                    </Tabs>
                    <SwipeableViews axis="x" index={value} className="m20">
                        <div dir="x" style={{ overflow: "hidden" }}>
                            { value === 0 && ({
                                "DRAFT": <LoanDraft clientId={car.client}
                                                    status={status}
                                                    contractStatus={contractStatus}
                                                    isNKBIRequested={isNKBIRequested}
                                                    isNKBIFetched={isNKBIFetched}
                                                    nkbiReportLink={nkbiReportLink}
                                                    nkbiRequestDate={nkbiRequestDate}
                                                    nkbiRequestId={nkbiRequestId}
                                                    nkbi={nkbi} />,
                                "SECURITY_CHECK": <LoanSecurityCheck carId={carId} />,
                                "APPROVED": <LoanApproved onClientDetailsSubmit={onClientDetailsSubmit}
                                                          onCarDetailsSubmit={onCarDetailsSubmit}
                                                          onProgramDetailsSubmit={onProgramDetailsSubmit}
                                                          onContractSign={onContractSign}
                                                          car={car}
                                                          client={client}
                                                          contractStatus={contractStatus} />,
                                "ACTIVE": <LoanActive userPermissions={userPermissions}
                                                      status={status}
                                                      car={car}
                                                      manager={manager}
                                                      client={client}
                                                      onAddComment={onAddComment}
                                                      onDeleteComment={onDeleteComment}
                                                      onContractIncrease={onContractIncrease}
                                                      onContractRepay={onContractRepay} />,
                                "TRADE": <LoanTrade carId={carId}
                                                    tradeStatus={tradeStatus}
                                                    prices={prices}
                                                    carDetails={carDetails}
                                                    trader={trader}
                                                    purchaser={purchaser}
                                                    onStatusSubmit={onStatusSubmit}
                                                    onTradeStatusSubmit={onTradeStatusSubmit}
                                                    onTradeCar={onTradeCar} />,
                                "CLOSED": <LoanClosed car={car}
                                                      contractId={contractId}
                                                      sum={sum}
                                                      trader={trader}
                                                      manager={manager}
                                                      onAddComment={onAddComment}
                                                      onDeleteComment={onDeleteComment}
                                                      tradeStatus={tradeStatus}
                                                      isJur={client.isJuridicalPerson}
                                                      programType={programType}
                                                      onDuplicateClient={onDuplicateClient} />,
                                "DENIED": <LoanDenied car={car} onDuplicateClient={onDuplicateClient} />,
                            })[status] }
                        </div>
                        <div dir="x" style={{ overflow: "hidden" }}>
                            { value === 1 && <Gallery car={car} isJur={client.isJuridicalPerson} /> }
                        </div>
                        <div dir="x" style={{ overflow: "hidden" }}>
                            { value === 2 && <LoanInfo client={client} car={car} /> }
                        </div>
                        <div dir="x" style={{ overflow: "hidden", padding: 10 }}>
                            { value === 3 &&
                                <LoanDraft clientId={car.client}
                                           isNKBIRequested={isNKBIRequested}
                                           status={status}
                                           contractStatus={contractStatus}
                                           isNKBIFetched={isNKBIFetched}
                                           nkbiReportLink={nkbiReportLink}
                                           nkbiRequestDate={nkbiRequestDate}
                                           nkbiRequestId={nkbiRequestId}
                                           nkbi={nkbi} />
                            }
                        </div>
                    </SwipeableViews>
                </div>
            </Fade>
        );
    }
}

const mapStateToProps = (state, {match}) => ({
    ...state.client,
    clientId: match.params.clientId,
    carId: match.params.carId,
    manager: state.common.user.id,
    userPermissions: state.common.user.permissions
});

const mapDispatchToProps = (dispatch, {match}) => ({
    onLoad: client =>
        dispatch({
            type: CLIENT_LOADED,
            payload: {
                ...client,
                id: match.params.clientId,
                carId: match.params.carId,
            }
        }),
    onStatusSubmit: (id, status) =>
        agent.Clients.setStatus(id, status)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
    onDuplicateClient: (car, full) =>
        agent.Clients.duplicateClient(car, full)
        .then(res => dispatch({type: DUPLICATE_CLIENT, payload: res})),
    onClientDetailsSubmit: (loanData, clientDetails, swipe) =>
        agent.Contract.setClientDetails(loanData, clientDetails)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(swipe),
    onCarDetailsSubmit: (contractId, carDetails, swipe) =>
        agent.Contract.setCarDetails(contractId, carDetails)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(swipe),
    onProgramDetailsSubmit: (contractId, programDetails, swipe) =>
        agent.Contract.setProgramDetails(contractId, programDetails)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(swipe),
    onContractSign: (contractId, signDetails, transactions) =>
        agent.Contract.sign(contractId, signDetails, transactions)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
    onTradeCar: (carId, data, swipe) =>
        agent.Clients.tradeCar(carId, data)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client}))
        .then(swipe),
    onTradeStatusSubmit: (carId, status) =>
        agent.Clients.tradeStatus(carId, status)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
    onAddComment: (id, details) =>
        agent.Clients.addComment(id, details)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client}))
        .then(dispatch(reset('comment-form'))),
    onDeleteComment: (carId, commentId) =>
        agent.Clients.deleteComment(carId, commentId)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client })),
    onContractIncrease: (contractId, oldSum, data, transactions) =>
        agent.Contract.increase(contractId, oldSum, data, transactions)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(() => dispatch(reset("contract-increase-form")))
        .then(() => dispatch({ type: MESSAGE_SENDED, payload: { text: "Сумма займа увеличена", type: "success" } })),
    onContractRepay: (contractId, oldSum, data, transactions) =>
        agent.Contract.repay(contractId, oldSum, data, transactions)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(dispatch(reset("contract-repay-form")))
        .then(() => dispatch({ type: MESSAGE_SENDED, payload: { text: "Сумма займа уменьшена", type: "success" } })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Loan);



// WEBPACK FOOTER //
// ./src/components/Loan.js